import { PostalAddress } from '../../../common/model/postal-address';
import { LocalDate } from '../../../core/model/local-date';
import { ModelBase } from '../../../core/model/model-base';

export class TransferBuyer extends ModelBase {
  constructor(model?: any) {
    super();
    if (model) {
      this.id = model.id;
      this.contactId = model.contactId;
      this.acquiredShare = model.acquiredShare;
      this.name = model.name;
      this.email = model.email;
      this.phone = model.phone;
      this.approvalDate = LocalDate.fromDate(model.approvalDate);
      this.memberFrom = LocalDate.fromDate(model.memberFrom);
    }
  }

  contactId: string;
  acquiredShare: number;
  name: string;
  email: string;
  phone: string;
  approvalDate: LocalDate;
  memberFrom: LocalDate;
}
